import { render, staticRenderFns } from "./RegistrationForm.vue?vue&type=template&id=35c4289c&"
import script from "./RegistrationForm.vue?vue&type=script&lang=ts&"
export * from "./RegistrationForm.vue?vue&type=script&lang=ts&"
import style0 from "./RegistrationForm.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./RegistrationForm.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
import { VStepper } from 'vuetify/lib/components/VStepper';
import { VStepperContent } from 'vuetify/lib/components/VStepper';
import { VStepperHeader } from 'vuetify/lib/components/VStepper';
import { VStepperItems } from 'vuetify/lib/components/VStepper';
import { VStepperStep } from 'vuetify/lib/components/VStepper';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VDivider,VForm,VStepper,VStepperContent,VStepperHeader,VStepperItems,VStepperStep,VTextField})
